import React from "react";
import PropTypes from "prop-types";
import Setting from "../../components/adm/setting";
import Layout from "../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const SettingsPage = () => {
  // let { uuid } = useParams();
  return <Layout body={<Setting />} />;
};

SettingsPage.propTypes = {};

export default SettingsPage;
